<template>
  <div class="line-message-wrapper" v-if="errors.length > 0">
    <div class="line-message-item" v-for="(error, index) in errors" :key="index">
      <i class="fa-regular fa-circle-exclamation" />
      <span class="message-text" v-text="error" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { IUIErrorMessage } from '@/types/Components'

  const { errors } = defineProps<IUIErrorMessage>()
</script>

<style lang="scss">
  .line-message-wrapper {
    width: 100%;
    margin-bottom: 0.5rem;

    .line-message-item {
      display: flex;
      align-items: center;
      font-size: 0.75rem;
      margin-bottom: 0.25rem;
      color: $danger;
      .message-text {
        margin-left: 0.25rem;
        display: flex;
        align-items: center;
      }
    }
  }
</style>
